import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { Observable, map } from "rxjs";
import { IActionOdataResult } from "../models/interfaces/action-result.interface";
import { IParamObj, IParamQuery } from "../models/interfaces/param-query.interface";
import { ITravelLocationType } from "../models/interfaces/travel.interface";

@Injectable({
    providedIn: 'root'
})
export class TravelLocationTypeService {
    constructor(private http: HttpClient) { }
    /**
     * Returns an array of event types based on http query params
     */
    public get(params?: IParamObj): Observable<Array<ITravelLocationType>> {
        const paramQuery: IParamQuery = (params) ? { params: params } : null;
        return this.getTravelLocationTypes(paramQuery).pipe(map((result) => result.value as Array<ITravelLocationType>));
    }

    private getTravelLocationTypes(paramQuery: IParamQuery): Observable<IActionOdataResult> {
        const httpParams = (paramQuery) ? paramQuery : {};
        return this.http.get<IActionOdataResult>(environment.apiBaseURL + 'odata/TravelLocationTypes', httpParams);
    }
}